import { render, staticRenderFns } from "./DrawingInfo.vue?vue&type=template&id=c165e79a&"
import script from "./DrawingInfo.vue?vue&type=script&lang=js&"
export * from "./DrawingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports